import { WindowTitle } from "@saleor/components/WindowTitle";
import { asSortParams } from "@saleor/utils/sort";
import { getArrayQueryParamFromParsed } from "@saleor/utils/urls";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, Routes, useLocation, useParams } from "react-router-dom";

import {
  CouponCollectionDetailsQueryParams,
  CouponRedemptionListUrlSortField,
  CouponsListUrlQueryParams,
  CouponsRedemptionListUrlQueryParams
} from "./url";
import CouponAddUnlockCodePage from "./views/CouponAddUnlockCodePage";
import CouponCollectionCreateComponent from "./views/CouponCollectionCreatePage";
import CouponCollectionDetailsComponent from "./views/CouponCollectionDetailsPage";
import CouponCollectionListComponent from "./views/CouponCollectionListPage/CouponCollectionListPage";
import CouponCreateComponent from "./views/CouponCreatePage/CouponCreatePage";
import CouponFullDetailsView from "./views/CouponDetailsPage/";
import CouponEditUnlockCodePage from "./views/CouponEditUnlockCodePage/CouponEditUnlockCodePage";
import CouponListComponent from "./views/CouponList/CouponList";
import CouponRankingListComponent from "./views/CouponRankingList";
import CouponRedemptionListComponent from "./views/CouponRedemptionList/CouponRedemptionList";
import CouponSetCodesPage from "./views/CouponSetCodesPage";

const CouponList: React.FC = () => {
  const location = useLocation();
  const qs = parseQs(location.search.substr(1));
  const params: CouponsListUrlQueryParams = {
    ...qs
  };

  return <CouponListComponent params={params} />;
};

const CouponCollectionList: React.FC = () => {
  const location = useLocation();
  const qs = parseQs(location.search.substr(1));
  const params = { ...qs };

  return <CouponCollectionListComponent params={params} />;
};

const CouponCollectionCreate: React.FC = () => (
  <CouponCollectionCreateComponent />
);

const CouponCollectionDetails: React.FC = () => {
  const location = useLocation();
  const { id } = useParams();
  const qs = parseQs(location.search.substr(1));
  const params: CouponCollectionDetailsQueryParams = {
    ...qs
  };

  return (
    <CouponCollectionDetailsComponent
      id={decodeURIComponent(id)}
      params={params}
    />
  );
};

const CouponRankingList: React.FC = () => {
  const location = useLocation();
  const qs = parseQs(location.search.substr(1));
  const params: CouponsListUrlQueryParams = {
    ...qs
  };

  return <CouponRankingListComponent params={params} />;
};

const CouponRedemptionList: React.FC = () => {
  const location = useLocation();
  const { id } = useParams();
  const qs = parseQs(location.search.substr(1));
  const statusArr = getArrayQueryParamFromParsed(qs.status);
  const hasClaimedStatus = statusArr.includes("CLAIMED");
  if (hasClaimedStatus) {
    statusArr.push("EXPIRED");
  }
  const params = asSortParams(
    { ...qs, status: statusArr },
    CouponRedemptionListUrlSortField
  ) as CouponsRedemptionListUrlQueryParams;

  return (
    <CouponRedemptionListComponent
      params={params}
      id={decodeURIComponent(id)}
    />
  );
};

const CouponCreate: React.FC = () => <CouponCreateComponent />;

const CouponFullDetails: React.FC = () => {
  const location = useLocation();
  const { id } = useParams();
  const qs = parseQs(location.search.substr(1));
  const params: any = {
    ...qs
  };

  return <CouponFullDetailsView id={decodeURIComponent(id)} params={params} />;
};

const CouponSetCodes: React.FC = () => {
  const { id } = useParams();

  return <CouponSetCodesPage couponId={decodeURIComponent(id)} />;
};

const CouponAddUnlockCode: React.FC = () => {
  const { id } = useParams();

  return <CouponAddUnlockCodePage couponId={decodeURIComponent(id)} />;
};

const CouponEditUnlockCode: React.FC = () => {
  const { couponId, unlockCodeId } = useParams();

  return (
    <CouponEditUnlockCodePage
      couponId={decodeURIComponent(couponId)}
      unlockCodeId={decodeURIComponent(unlockCodeId)}
    />
  );
};

const Component = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle
        title={intl.formatMessage({
          defaultMessage: "Coupons",
          description: "coupons report section name"
        })}
      />
      <Routes>
        <Route path={"collection"} element={<CouponCollectionList />} />
        <Route path={"manage"} element={<CouponList />} />
        <Route path={"manage/add-coupons"} element={<CouponCreate />} />
        <Route
          path={"collection/add-collection"}
          element={<CouponCollectionCreate />}
        />
        <Route
          path={"collection/view-collection/:id"}
          element={<CouponCollectionDetails />}
        />
        <Route path={"coupon-ranking"} element={<CouponRankingList />} />
        <Route path={"manage/:id"} element={<CouponFullDetails />} />
        <Route path={"manage/:id/set-codes"} element={<CouponSetCodes />} />
        <Route
          path={"manage/:id/set-codes/add-unlock-codes"}
          element={<CouponAddUnlockCode />}
        />
        <Route
          path={"manage/:couponId/set-codes/edit-unlock-codes/:unlockCodeId"}
          element={<CouponEditUnlockCode />}
        />
        <Route
          path={"manage/coupon-redemption/:id"}
          element={<CouponRedemptionList />}
        />
      </Routes>
    </>
  );
};

export default Component;
